import { render } from "./Index.vue?vue&type=template&id=46ea2260&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-46ea2260"

export default script